import { formQueries } from "@circle-react/lib/queries/forms";
import { useQuery } from "react-query";

import { t } from "@/i18n-js/instance";

export interface UseGetFormProps {
  id?: number;
}

export const useGetForm = (
  { id }: UseGetFormProps,
  options: Record<string, unknown> = {},
) =>
  useQuery({
    ...formQueries.detail(id ?? 0),
    enabled: id !== undefined,
    meta: { errorMessage: t("error") },
    ...options,
  });
